import { AppConfigModel } from "../abstract/app-config.model";

/**
 * Règle qui a désigné le partenaire d'une facture passée par le pipeline OCR
 * (`alias`, `exact_name`, `contained_name`, `identifier_vote`…).
 *
 * Lecture seule : le back la pose à l'étape d'identification du tiers et vide
 * le champ quand aucune résolution automatique n'a eu lieu — y compris par
 * abstention, quand plusieurs partenaires étaient plausibles.
 */
export class PartnerResolutionStrategy extends AppConfigModel {

    static override CLASS_NAME: string = 'PartnerResolutionStrategy';
}
